export default __webpack_public_path__ + "static/404-ad38f1215288e84cdcaa0b2d4b936a9f.svg";